// extracted by mini-css-extract-plugin
export default {"maintenance":"maintenancePage_maintenance__imHdd","main-text":"maintenancePage_main-text__WbMnt","caption-text":"maintenancePage_caption-text__Jt-Pd"};